var map = {
	"./html": 765,
	"./html.js": 765,
	"./md": 766,
	"./md.js": 766
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 764;



//////////////////
// WEBPACK FOOTER
// ../~/gatsby/dist/isomorphic/wrappers ^\.\/.*$
// module id = 764
// module chunks = 0